(function(app) {
    app.JustificationSelection = {
        init() {
            const justificationRadioEls = document.querySelectorAll('.wdpp-radio--justification');
            const justificationDisplayEl = document.querySelector('.wdpp-display--justification');

            // Validate required elements
            if (!app.Utils.validateElements('justification inputs', {
                'justification radio buttons': justificationRadioEls,
                'justification display element': '.wdpp-display--justification'
            })) {
                return;
            }

            justificationRadioEls.forEach(radio => {
                radio.addEventListener('change', () => {
                    if (radio.checked) {
                        app.Store.setState('justification', radio.value);
                        console.log(`Justification changed to: ${radio.value}`);
                    }
                });
            });

            // Initialize display
            const currentValue = app.Store.getState('justification');
            if (currentValue) {
                this.updateJustificationDisplay(currentValue);
            }

            // Subscribe to store changes
            app.Store.subscribe('justification', (value) => this.updateJustificationDisplay(value));

            // Set initial value in store
            const checkedRadio = Array.from(justificationRadioEls).find(r => r.checked);
            if (checkedRadio) {
                app.Store.subscribe('initialized', () => {
                    app.Store.setState('justification', checkedRadio.value);
                });
            }
        },

        updateJustificationDisplay(value) {
            const displayEl = document.querySelector(`.wdpp-display--justification`);
            const radioEls = document.querySelectorAll(`.wdpp-radio--justification`);
            if (displayEl && radioEls.length) {
                const checkedRadio = Array.from(radioEls).find(r => r.value === value);
                if (checkedRadio) {
                    // displayEl.textContent = checkedRadio.closest('label') ? checkedRadio.closest('label').textContent.trim() : checkedRadio.value;
                    displayEl.textContent = checkedRadio.getAttribute('data-justification-friendly-name');
                }
            }
        },
        
        /**
         * Get the justification data for cart export
         * @returns {object} The justification data for the cart
         */
        getCartData() {
            return {
                justification: app.Store.getState('justification') || ''
            };
        },

        /**
         * Get the justification data for price calculation
         * @returns {object} The justification data for the price
         */
        getPriceData() {
            return {
                justification: app.Store.getState('justification') || ''
            };
        }
    };
})(window.app = window.app || {});